// Найти индекс элемента в наборе по значению

/**
 * Найти индекс элемента в наборе по значению
 * 
 * @param items Массив объектов с параметром `value`.
 * @param value Искомое значение.
 * @returns Индект элемента с искомым значением, или `-1`.
 */
function getIndexByValue( items: Array<{value: string}>, value: string ): number
{
	for ( let i = 0, n = items.length; i < n; i++ )
	{
		if ( items[i].value === value )
		{
			return i;
		}
	}
	
	return -1;
}

/**
 * Module
 */
export {
	getIndexByValue as default,
};



// WEBPACK FOOTER //
// ./app/Routes/Choose/App/utils/getIndexByValue.ts